
<template>
  <div class="row">
    <div class="col">
      <div class="card card-modern">
        <div class="card-body">
          <div class="datatables-header-footer-wrapper">
            <div class="datatable-header">
              <div class="row align-items-center mb-3">
                <div class="col-12 col-lg-auto mb-3 mb-lg-0">
                  <router-link class="btn btn-primary btn-md font-weight-semibold btn-py-2 px-4" :to="{ name: 'AddMeasurementUnit' }">+ Dodaj jedinicu mjere</router-link>
                </div>
                <div class="col-8 col-lg-auto ms-auto ml-auto mb-3 mb-lg-0">
                  <div class="d-flex align-items-lg-center flex-column flex-lg-row">
                  </div>
                </div>
                <div class="col-4 col-lg-auto ps-lg-1 mb-3 mb-lg-0">
                  <div class="d-flex align-items-lg-center flex-column flex-lg-row">
                    <label class="ws-nowrap me-3 mb-0">Show:</label>
                    <select
                      class="form-control select-style-1 results-per-page"
                      name="results-per-page"
                      v-model="searchConfig.pageSize"
                      @change="changePageSize(searchConfig.pageSize)"
                    >
                      <option
                        :value="page"
                        v-for="page in pageSizeList"
                        :key="page"
                      >{{ page }}</option>
                    </select>
                  </div>
                </div>
                <div class="col-12 col-lg-auto ps-lg-1">
                  <div class="search search-style-1 search-style-1-lg mx-lg-auto">
                    <div class="input-group">
                      <input
                        type="text"
                        class="search-term form-control"
                        placeholder="Search"
                        v-model="searchField"
                        @input="debounceInput"
                      />
                      <button class="btn btn-default" type="submit">
                        <i class="bx bx-search"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="dataTables_wrapper dt-bootstrap5 no-footer" v-if="measurementUnits.length > 0">
              <div class="table-responsive">
                <table
                  class="
                    table table-ecommerce-simple table-striped
                    mb-0
                    dataTable
                    no-footer
                  "
                >
                  <thead>
                    <tr role="row">
                      <th class="sorting">Rbr</th>
                      <th class="sorting">Title</th>
                      <th class="sorting">Description</th>
                      <th class="sorting">Datum kreiranja</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      role="row"
                      v-for="(unit, index) in measurementUnits"
                      :key="unit.id"
                      @click="openDetails(unit.id)"
                      :class="{ odd: index % 2 === 0, even: index % 2 !== 0 }"
                    >
                      <td>
                          <strong>{{ ((pager.currentPage - 1) * (searchConfig.pageSize)) + index + 1 }}</strong>
                      </td>
                      <td>
                          <strong>{{ unit.title }}</strong>
                      </td>
                      <td>{{ unit.description }}</td>
                      <td>{{ formatDate(unit.createdDate) }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div v-else>
              <div class="alert alert-info" role="alert">
                {{ translations.noRecords }} <a class="alert-link" @click.prevent="resetFilters">{{ translations.resetFilters }}</a>.
              </div>
            </div>
            <hr class="solid mt-5 opacity-4" />
          </div>
        </div>
      </div>
    </div>
    <!-- end: page -->
  </div>
</template>
<script>
import { translations, pager } from '@/mixins';

export default {
  name: 'MeasurementUnits',
  mixins: [translations, pager],
  data() {
    return {
      actionName: 'getMeasurementUnits',
    };
  },
  computed: {
    measurementUnits() {
      return this.$store.getters.getMeasurementUnits;
    },
  },
  mounted() {
    this.$store.dispatch(this.actionName, this.searchConfig);
  },
  methods: {
    openDetails(id) {
      this.$router.push({ name: 'EditMeasurementUnit', params: { id: id } });
    },
  }
}
</script>
<style lang="scss" scoped>
.sorting {
  cursor: pointer;
}

tbody tr {
  cursor: pointer;
}
</style>
